var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScountAgentLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.98641e-05 23.9354C2.98641e-05 23.563 0.262529 23.2443 0.624141 23.1586C11.7698 20.5363 20.5819 11.7586 23.2123 0.629464C23.298 0.262498 23.6221 0 23.9971 0C24.3748 0 24.6962 0.262498 24.7846 0.629464C27.4069 11.7881 36.2168 20.5796 47.3837 23.1778C47.7426 23.2608 47.9998 23.5769 47.9998 23.9465C47.9998 24.3135 47.7426 24.6296 47.3837 24.7126C36.1709 27.3242 27.3375 36.1743 24.7523 47.3946C24.672 47.7455 24.3613 48 23.9996 48C23.638 48 23.3273 47.7455 23.2469 47.3946C20.6621 36.1771 11.8332 27.3266 0.626541 24.7154C0.262254 24.6296 2.98641e-05 24.3103 2.98641e-05 23.9354Z",
    fill: "url(#paint0_linear_22_467)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22_467",
    x1: 23.9998,
    y1: 0,
    x2: 23.9998,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#027A3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3D7C4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScountAgentLogo);
export default __webpack_public_path__ + "static/media/scount-agent-logo.f94b830eaf45ab4e5281e8392395c3c0.svg";
export { ForwardRef as ReactComponent };